export default "__VITE_ASSET__9ff20316__"